import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, TrendingUp, Wallet, Clock, Layers, AlertCircle } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import styles from './ComparisonSection.module.css';

const ComparisonSection = () => {
  const brandOrange = "#e87355";
  const brandBlue = "#5ba5e0";
  const { t } = useLanguage();

  return (
    <section className={styles.container} id="why">
      <div className={styles.wrapper}>
        
        {/* --- HEADER --- */}
        <div className={styles.header}>
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className={styles.title}
          >
            {t('why_title')} <span className={styles.accent}>{t('why_accent')}</span>
          </motion.h2>
          <p className={styles.subTitle}>
            {t('why_subtitle')}
          </p>
        </div>

        <div className={styles.stackContainer}>
          
          {/* --- THE PROBLEM (COMPETITION) --- */}
          <motion.div 
            className={styles.problemCard}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className={styles.cardLabel}><AlertCircle size={14}/> {t('why_old_badge')}</div>
            <h3 className={styles.cardHeading}>{t('why_old_heading')}</h3>
            
            <div className={styles.pointsList}>
              <div className={styles.point}>
                <XCircle color="#ef4444" size={20} className={styles.flexIcon} />
                <div>
                  <strong>{t('why_old_p1')}</strong>
                  <span className={styles.priceTag}>{t('why_old_p1_cost')}</span>
                </div>
              </div>
              
              <div className={styles.point}>
                <XCircle color="#ef4444" size={20} className={styles.flexIcon} />
                <div><strong>{t('why_old_p2')}</strong></div>
              </div>

              <div className={styles.point}>
                <XCircle color="#ef4444" size={20} className={styles.flexIcon} />
                <div><strong>{t('why_old_p3')}</strong></div>
              </div>
            </div>
          </motion.div>

          {/* --- THE SOLUTION (ANANTA) --- */}
          <motion.div 
            className={styles.solutionCard}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <div className={styles.popularBadge}>{t('why_new_badge')}</div>
            <h3 className={styles.cardHeading}>{t('why_new_heading')}</h3>
            
            <div className={styles.solutionGrid}>
              <div className={styles.solItem}>
                <div className={styles.solIcon} style={{background: `${brandOrange}20`}}>
                  <Wallet color={brandOrange} size={22} />
                </div>
                <div>
                  <h4>{t('why_new_p1_title')}</h4>
                  <p>{t('why_new_p1_desc')}</p>
                </div>
              </div>

              <div className={styles.solItem}>
                <div className={styles.solIcon} style={{background: `${brandBlue}20`}}>
                  <Clock color={brandBlue} size={22} />
                </div>
                <div>
                  <h4>{t('why_new_p2_title')}</h4>
                  <p>{t('why_new_p2_desc')}</p>
                </div>
              </div>

              <div className={styles.solItem}>
                <div className={styles.solIcon} style={{background: `${brandOrange}20`}}>
                  <Layers color={brandOrange} size={22} />
                </div>
                <div>
                  <h4>{t('why_new_p3_title')}</h4>
                  <p>{t('why_new_p3_desc')}</p>
                </div>
              </div>

              <div className={styles.solItem}>
                <div className={styles.solIcon} style={{background: `${brandBlue}20`}}>
                  <TrendingUp color={brandBlue} size={22} />
                </div>
                <div>
                  <h4>{t('why_new_p4_title')}</h4>
                  <p>{t('why_new_p4_desc')}</p>
                </div>
              </div>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;